import type { RouteRecordRaw } from 'vue-router'
import { ROUTES } from '@/router/routes.enum'
import { ACTION_ROLES } from '@/utils/constants'
import { requireAuthenticatedUser } from '@/router/guards'

export const customerRoutes: RouteRecordRaw[] = [
  {
    path: '/customers',
    name: ROUTES.CUSTOMERS,
    component: () => import('@/modules/customers/views/CustomersIndex.view.vue'),
    beforeEnter: requireAuthenticatedUser,
    meta: { roles: ACTION_ROLES.CUSTOMERS_VIEW }
  },
  {
    path: '/customers/:id',
    name: ROUTES.CUSTOMER_DETAILS,
    component: () => import('@/modules/customers/views/CustomerDetails.view.vue'),
    beforeEnter: requireAuthenticatedUser,
    meta: { roles: ACTION_ROLES.CUSTOMER_DETAILS_VIEW }
  }
]
